import { MdHome } from "react-icons/md";
import { HeaderItemDTO } from "../typings/generic";
import { FaInbox, FaUser } from "react-icons/fa";
import { BsChatTextFill } from "react-icons/bs";
import { FaListAlt } from "react-icons/fa";
import { IoIosSettings } from "react-icons/io";
import { LuFileKey2 } from "react-icons/lu";
import { IoMdNotificationsOutline } from "react-icons/io";
import { RiFileSettingsFill, RiLockPasswordFill } from "react-icons/ri";
import { CiSettings } from "react-icons/ci";
import { IoReceipt } from "react-icons/io5";
import { BsCalendar3EventFill } from "react-icons/bs";
import {
  dashboard,
  department,
  modularapp,
  NotificationIcon,
  settings,
} from "./import";
import { HiMiniSquares2X2 } from "react-icons/hi2";
import { MdDeveloperMode } from "react-icons/md";

import path from "path";

const data: [] = [];



const HRMmodules = [
  {
    id: 1,
    moduleName: "Employee",
    moduleUID: "HRM",
    status: "active",
    amount: 26835,
    description:
      "Manage employee information, recruitment, payroll, and performance appraisals.",
    features:
      "Employee information, Recruitment and onboarding, Payroll and benefits administration, Performance appraisals, Training and development",
    createdAt: "2024-08-05T03:04:44.707Z",
    updatedAt: "2024-08-05T03:04:44.707Z",
  },
];

const HeaderItems: HeaderItemDTO[] = [
  {
    title: "Home",
    icon: <MdHome />,
    path: "/home",
  },

  {
    title: "Activity",
    icon: <FaInbox />,
    path: "/home/activity",
  },
  {
    title: "Chat",
    icon: <BsChatTextFill />,
    path: "/home/chat",
  },
  {
    title: "Help",
    icon: <FaListAlt />,
    path: "/home/help",
  },
  {
    title: "Settings",
    icon: <IoIosSettings />,
    path: "/home/settings",
  },
];

const HelpItems = [
  {
    title: "How do I change my account email?",
    body: "You can log in to your account and change it from your Profile > Edit Profile. Then go to the general tab to change your email.",
  },
  {
    title: "How do I change my account email?",
    body: "You can log in to your account and change it from your Profile > Edit Profile. Then go to the general tab to change your email.",
  },
  {
    title: "How do I change my account email?",
    body: "You can log in to your account and change it from your Profile > Edit Profile. Then go to the general tab to change your email.",
  },
  {
    title: "How do I change my account email?",
    body: "You can log in to your account and change it from your Profile > Edit Profile. Then go to the general tab to change your email.",
  },
  {
    title: "How do I change my account email?",
    body: "You can log in to your account and change it from your Profile > Edit Profile. Then go to the general tab to change your email.",
  },
];

const NavItemTooltipItems = [
  {
    title: "Home",
    desc: "This is where you can create a company or business profile and view the list of companies or businesses that have been created.",
  },
  {
    title: "Activity",
    desc: "This is where you can view notifications about activities across the companies you have created and activities of the users.",
  },
  {
    title: "Chat",
    desc: "This is where you view and send messsages to other users on the platform, current chat history ",
  },
  {
    title: "Help",
    desc: "Access help and support resources here, including FAQs, user guides, and contact options for additional assistance.",
  },

  {
    title: "Settings",
    desc: "Access general settings, edit company profile, manage roles and permissions, and change your password.",
  },
  {
    title: "Account",
    desc: "Access general settings, edit company profile, manage roles and permissions, and change your password.",
  },
];

const contractTypes = [
  { code: "Internship", name: "Internship" },
  { code: "Fulltime", name: "Full-Time" },
  { code: "Parttime", name: "Part-Time" },
  // { code: "Temporary contract", name: "Temporary contract" },
  // { code: "Freelance", name: "Freelance" },
  // { code: "Consultancy", name: "Consultancy" },
  // { code: "Agency", name: "Agency" },
  // { code: "NonDisclosure Agreement", name: "Non-Disclosure Agreement" },
  // { code: "Service Agreement", name: "Service Agreement" },
  // { code: "Apprenticeship", name: "Apprenticeship" },
];



const wageTypes = [
  { code: "Fixed", name: "Fixed" },
  { code: "Commision Based", name: "Fixed" },
  { code: "Hourly", name: "Hourly" },
  { code: "Daily", name: "Daily" },
  { code: "Weekly", name: "Weekly" },
  { code: "Montly", name: "Monthly" },
  { code: "Annually", name: "Annually" },
];
const countries = [
  { name: "Afghanistan", code: "AF" },
  { name: "land Islands", code: "AX" },
  { name: "Albania", code: "AL" },
  { name: "Algeria", code: "DZ" },
  { name: "American Samoa", code: "AS" },
  { name: "AndorrA", code: "AD" },
  { name: "Angola", code: "AO" },
  { name: "Anguilla", code: "AI" },
  { name: "Antarctica", code: "AQ" },
  { name: "Antigua and Barbuda", code: "AG" },
  { name: "Argentina", code: "AR" },
  { name: "Armenia", code: "AM" },
  { name: "Aruba", code: "AW" },
  { name: "Australia", code: "AU" },
  { name: "Austria", code: "AT" },
  { name: "Azerbaijan", code: "AZ" },
  { name: "Bahamas", code: "BS" },
  { name: "Bahrain", code: "BH" },
  { name: "Bangladesh", code: "BD" },
  { name: "Barbados", code: "BB" },
  { name: "Belarus", code: "BY" },
  { name: "Belgium", code: "BE" },
  { name: "Belize", code: "BZ" },
  { name: "Benin", code: "BJ" },
  { name: "Bermuda", code: "BM" },
  { name: "Bhutan", code: "BT" },
  { name: "Bolivia", code: "BO" },
  { name: "Bosnia and Herzegovina", code: "BA" },
  { name: "Botswana", code: "BW" },
  { name: "Bouvet Island", code: "BV" },
  { name: "Brazil", code: "BR" },
  { name: "British Indian Ocean Territory", code: "IO" },
  { name: "Brunei Darussalam", code: "BN" },
  { name: "Bulgaria", code: "BG" },
  { name: "Burkina Faso", code: "BF" },
  { name: "Burundi", code: "BI" },
  { name: "Cambodia", code: "KH" },
  { name: "Cameroon", code: "CM" },
  { name: "Canada", code: "CA" },
  { name: "Cape Verde", code: "CV" },
  { name: "Cayman Islands", code: "KY" },
  { name: "Central African Republic", code: "CF" },
  { name: "Chad", code: "TD" },
  { name: "Chile", code: "CL" },
  { name: "China", code: "CN" },
  { name: "Christmas Island", code: "CX" },
  { name: "Cocos (Keeling) Islands", code: "CC" },
  { name: "Colombia", code: "CO" },
  { name: "Comoros", code: "KM" },
  { name: "Congo", code: "CG" },
  { name: "Congo, The Democratic Republic of the", code: "CD" },
  { name: "Cook Islands", code: "CK" },
  { name: "Costa Rica", code: "CR" },
  { name: "Cote D'Ivoire", code: "CI" },
  { name: "Croatia", code: "HR" },
  { name: "Cuba", code: "CU" },
  { name: "Cyprus", code: "CY" },
  { name: "Czech Republic", code: "CZ" },
  { name: "Denmark", code: "DK" },
  { name: "Djibouti", code: "DJ" },
  { name: "Dominica", code: "DM" },
  { name: "Dominican Republic", code: "DO" },
  { name: "Ecuador", code: "EC" },
  { name: "Egypt", code: "EG" },
  { name: "El Salvador", code: "SV" },
  { name: "Equatorial Guinea", code: "GQ" },
  { name: "Eritrea", code: "ER" },
  { name: "Estonia", code: "EE" },
  { name: "Ethiopia", code: "ET" },
  { name: "Falkland Islands (Malvinas)", code: "FK" },
  { name: "Faroe Islands", code: "FO" },
  { name: "Fiji", code: "FJ" },
  { name: "Finland", code: "FI" },
  { name: "France", code: "FR" },
  { name: "French Guiana", code: "GF" },
  { name: "French Polynesia", code: "PF" },
  { name: "French Southern Territories", code: "TF" },
  { name: "Gabon", code: "GA" },
  { name: "Gambia", code: "GM" },
  { name: "Georgia", code: "GE" },
  { name: "Germany", code: "DE" },
  { name: "Ghana", code: "GH" },
  { name: "Gibraltar", code: "GI" },
  { name: "Greece", code: "GR" },
  { name: "Greenland", code: "GL" },
  { name: "Grenada", code: "GD" },
  { name: "Guadeloupe", code: "GP" },
  { name: "Guam", code: "GU" },
  { name: "Guatemala", code: "GT" },
  { name: "Guernsey", code: "GG" },
  { name: "Guinea", code: "GN" },
  { name: "Guinea-Bissau", code: "GW" },
  { name: "Guyana", code: "GY" },
  { name: "Haiti", code: "HT" },
  { name: "Heard Island and Mcdonald Islands", code: "HM" },
  { name: "Holy See (Vatican City State)", code: "VA" },
  { name: "Honduras", code: "HN" },
  { name: "Hong Kong", code: "HK" },
  { name: "Hungary", code: "HU" },
  { name: "Iceland", code: "IS" },
  { name: "India", code: "IN" },
  { name: "Indonesia", code: "ID" },
  { name: "Iran, Islamic Republic Of", code: "IR" },
  { name: "Iraq", code: "IQ" },
  { name: "Ireland", code: "IE" },
  { name: "Isle of Man", code: "IM" },
  { name: "Israel", code: "IL" },
  { name: "Italy", code: "IT" },
  { name: "Jamaica", code: "JM" },
  { name: "Japan", code: "JP" },
  { name: "Jersey", code: "JE" },
  { name: "Jordan", code: "JO" },
  { name: "Kazakhstan", code: "KZ" },
  { name: "Kenya", code: "KE" },
  { name: "Kiribati", code: "KI" },
  { name: "Korea, Democratic People'S Republic of", code: "KP" },
  { name: "Korea, Republic of", code: "KR" },
  { name: "Kuwait", code: "KW" },
  { name: "Kyrgyzstan", code: "KG" },
  { name: "Lao People'S Democratic Republic", code: "LA" },
  { name: "Latvia", code: "LV" },
  { name: "Lebanon", code: "LB" },
  { name: "Lesotho", code: "LS" },
  { name: "Liberia", code: "LR" },
  { name: "Libyan Arab Jamahiriya", code: "LY" },
  { name: "Liechtenstein", code: "LI" },
  { name: "Lithuania", code: "LT" },
  { name: "Luxembourg", code: "LU" },
  { name: "Macao", code: "MO" },
  { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
  { name: "Madagascar", code: "MG" },
  { name: "Malawi", code: "MW" },
  { name: "Malaysia", code: "MY" },
  { name: "Maldives", code: "MV" },
  { name: "Mali", code: "ML" },
  { name: "Malta", code: "MT" },
  { name: "Marshall Islands", code: "MH" },
  { name: "Martinique", code: "MQ" },
  { name: "Mauritania", code: "MR" },
  { name: "Mauritius", code: "MU" },
  { name: "Mayotte", code: "YT" },
  { name: "Mexico", code: "MX" },
  { name: "Micronesia, Federated States of", code: "FM" },
  { name: "Moldova, Republic of", code: "MD" },
  { name: "Monaco", code: "MC" },
  { name: "Mongolia", code: "MN" },
  { name: "Montenegro", code: "ME" },
  { name: "Montserrat", code: "MS" },
  { name: "Morocco", code: "MA" },
  { name: "Mozambique", code: "MZ" },
  { name: "Myanmar", code: "MM" },
  { name: "Namibia", code: "NA" },
  { name: "Nauru", code: "NR" },
  { name: "Nepal", code: "NP" },
  { name: "Netherlands", code: "NL" },
  { name: "Netherlands Antilles", code: "AN" },
  { name: "New Caledonia", code: "NC" },
  { name: "New Zealand", code: "NZ" },
  { name: "Nicaragua", code: "NI" },
  { name: "Niger", code: "NE" },
  { name: "Nigeria", code: "NG" },
  { name: "Niue", code: "NU" },
  { name: "Norfolk Island", code: "NF" },
  { name: "Northern Mariana Islands", code: "MP" },
  { name: "Norway", code: "NO" },
  { name: "Oman", code: "OM" },
  { name: "Pakistan", code: "PK" },
  { name: "Palau", code: "PW" },
  { name: "Palestinian Territory, Occupied", code: "PS" },
  { name: "Panama", code: "PA" },
  { name: "Papua New Guinea", code: "PG" },
  { name: "Paraguay", code: "PY" },
  { name: "Peru", code: "PE" },
  { name: "Philippines", code: "PH" },
  { name: "Pitcairn", code: "PN" },
  { name: "Poland", code: "PL" },
  { name: "Portugal", code: "PT" },
  { name: "Puerto Rico", code: "PR" },
  { name: "Qatar", code: "QA" },
  { name: "Reunion", code: "RE" },
  { name: "Romania", code: "RO" },
  { name: "Russian Federation", code: "RU" },
  { name: "RWANDA", code: "RW" },
  { name: "Saint Helena", code: "SH" },
  { name: "Saint Kitts and Nevis", code: "KN" },
  { name: "Saint Lucia", code: "LC" },
  { name: "Saint Pierre and Miquelon", code: "PM" },
  { name: "Saint Vincent and the Grenadines", code: "VC" },
  { name: "Samoa", code: "WS" },
  { name: "San Marino", code: "SM" },
  { name: "Sao Tome and Principe", code: "ST" },
  { name: "Saudi Arabia", code: "SA" },
  { name: "Senegal", code: "SN" },
  { name: "Serbia", code: "RS" },
  { name: "Seychelles", code: "SC" },
  { name: "Sierra Leone", code: "SL" },
  { name: "Singapore", code: "SG" },
  { name: "Slovakia", code: "SK" },
  { name: "Slovenia", code: "SI" },
  { name: "Solomon Islands", code: "SB" },
  { name: "Somalia", code: "SO" },
  { name: "South Africa", code: "ZA" },
  { name: "South Georgia and the South Sandwich Islands", code: "GS" },
  { name: "Spain", code: "ES" },
  { name: "Sri Lanka", code: "LK" },
  { name: "Sudan", code: "SD" },
  { name: "Suriname", code: "SR" },
  { name: "Svalbard and Jan Mayen", code: "SJ" },
  { name: "Swaziland", code: "SZ" },
  { name: "Sweden", code: "SE" },
  { name: "Switzerland", code: "CH" },
  { name: "Syrian Arab Republic", code: "SY" },
  { name: "Taiwan, Province of China", code: "TW" },
  { name: "Tajikistan", code: "TJ" },
  { name: "Tanzania, United Republic of", code: "TZ" },
  { name: "Thailand", code: "TH" },
  { name: "Timor-Leste", code: "TL" },
  { name: "Togo", code: "TG" },
  { name: "Tokelau", code: "TK" },
  { name: "Tonga", code: "TO" },
  { name: "Trinidad and Tobago", code: "TT" },
  { name: "Tunisia", code: "TN" },
  { name: "Turkey", code: "TR" },
  { name: "Turkmenistan", code: "TM" },
  { name: "Turks and Caicos Islands", code: "TC" },
  { name: "Tuvalu", code: "TV" },
  { name: "Uganda", code: "UG" },
  { name: "Ukraine", code: "UA" },
  { name: "United Arab Emirates", code: "AE" },
  { name: "United Kingdom", code: "GB" },
  { name: "United States", code: "US" },
  { name: "United States Minor Outlying Islands", code: "UM" },
  { name: "Uruguay", code: "UY" },
  { name: "Uzbekistan", code: "UZ" },
  { name: "Vanuatu", code: "VU" },
  { name: "Venezuela", code: "VE" },
  { name: "Viet Nam", code: "VN" },
  { name: "Virgin Islands, British", code: "VG" },
  { name: "Virgin Islands, U.S.", code: "VI" },
  { name: "Wallis and Futuna", code: "WF" },
  { name: "Western Sahara", code: "EH" },
  { name: "Yemen", code: "YE" },
  { name: "Zambia", code: "ZM" },
  { name: "Zimbabwe", code: "ZW" },
];

const ModulesMeta = [
  {
    name: "General Ledger",
    code: "",
    icon: (
      <IoReceipt
        size={50}
        className="inline p-2 ml-2 bg-blueGray text-white rounded-lg"
      />
    ),
    category: "Financial",
  },
  {
    name: "Financial reporting",
    code: "",
    icon: (
      <IoReceipt
        size={50}
        className="inline p-2 ml-2 bg-blueGray text-white rounded-lg"
      />
    ),
    category: "Financial",
  },
  {
    name: "Fixed asset management",
    code: "",
    icon: (
      <IoReceipt
        size={50}
        className="inline p-2 ml-2 bg-blueGray text-white rounded-lg"
      />
    ),
    category: "Financial",
  },
  {
    name: "Employment data management",
    code: "",
    icon: (
      <IoReceipt
        size={50}
        className="inline p-2 ml-2 bg-blueGray text-white rounded-lg"
      />
    ),
    category: "HRM",
  },
  {
    name: "Performance management",
    code: "",
    icon: (
      <IoReceipt
        size={50}
        className="inline p-2 ml-2 bg-blueGray text-white rounded-lg"
      />
    ),
    category: "HRM",
  },
  {
    name: "Financial management",
    code: "",
    icon: (
      <IoReceipt
        size={50}
        className="inline p-2 ml-2 bg-blueGray text-white rounded-lg"
      />
    ),
    category: "HRM",
  },
  {
    name: "Financial Management",
    code: "",
    icon: (
      <IoReceipt
        size={50}
        className="inline p-2 ml-2 bg-blueGray text-white rounded-lg"
      />
    ),
    category: "Inventory",
  },
  {
    name: "Financial Management",
    code: "",
    icon: (
      <IoReceipt
        size={50}
        className="inline p-2 ml-2 bg-blueGray text-white rounded-lg"
      />
    ),
    category: "Inventory",
  },
  {
    name: "Financial Management",
    code: "",
    icon: (
      <IoReceipt
        size={50}
        className="inline p-2 ml-2 bg-blueGray text-white rounded-lg"
      />
    ),
    category: "Inventory",
  },
];

const companySizes = [
  { name: "0-10 Employees", code: 10 },
  { name: "10-20 Employees", code: 20 },
  { name: "20-50 Employees", code: 50 },
  { name: "50-70 Employees", code: 70 },
  { name: " Over 70 Employees", code: 100 },
];

const TasksItems = [
  { name: "Create Account", checked: true },
  { name: "Verify Email", checked: true },
  { name: "Add Company", checked: true },
  { name: "Add Department", checked: false },
  { name: "Add User", checked: false },
  { name: "Install Module", checked: false },
  { name: "Activate 2FA/MFA", checked: false },
];

const UserSidebarSettingItems = [
  {
    title: "Users",
    path: "users",
    icon: <FaUser size={15} className="inline mr-1" />,
  },

  {
    title: "Companies",
    path: "company",
    icon: <BsCalendar3EventFill size={15} className="inline mr-1" />,
  },

  {
    title: "Departments",
    path: "departments",
    icon: <HiMiniSquares2X2 size={15} className="inline mr-1 " />,
  },
  {
    title: "Developer Mode",
    path: "devmode",
    icon: <MdDeveloperMode size={15} className="inline mr-1 " />,
  },
];
const GeneralSidebarSettingItems = [
  {
    title: "Preferences",
    path: "general",
    icon: <RiFileSettingsFill size={15} className="inline mr-1" />,
  },
  {
    title: "Notifications",
    path: "notification",

    icon: <img className="inline " src={NotificationIcon} />,
  },
  {
    title: "Password & Security",
    path: "passandsec",
    icon: <RiLockPasswordFill size={15} className="inline mr-1 " />,
  },
];
const SidebarSettingsItem = [
  {
    title: "Company profile",
    path: "company",
    icon: <BsCalendar3EventFill size={15} className="inline mr-1" />,
  },
  {
    title: "Users",
    path: "users",
    icon: <FaUser size={15} className="inline mr-1" />,
  },

  {
    title: "Departments",
    path: "department",
    icon: <HiMiniSquares2X2 size={15} className="inline mr-1 " />,
  },
];

export {
  data,
  contractTypes,
  HRMmodules,
  GeneralSidebarSettingItems,
   NavItemTooltipItems,
  TasksItems,
  HeaderItems,
  HelpItems,
  countries,
  SidebarSettingsItem,
  wageTypes,
  ModulesMeta,
  companySizes,
  UserSidebarSettingItems,
};
